"use client"

import React from "react"
import { useLocale } from "hooks"
import { useTrustPilotWidget } from "./TrustPilotWidget.hooks"
import { trustPilotReviewWidgetContainer } from "./style.css"
import { trustPilotConfig } from "./constants"

type Props = {
  trustPilotBackgroundColor?: string
}

export const TrustPilotReviewWidget: React.FC<Props> = ({
  trustPilotBackgroundColor,
}) => {
  const { trustPilotContainerRef } = useTrustPilotWidget()
  const locale = useLocale()
  const backgroundColor =
    trustPilotBackgroundColor === "black" ? "dark" : "light"

  return (
    <div className={trustPilotReviewWidgetContainer}>
      <div
        ref={trustPilotContainerRef}
        className="trustpilot-widget"
        data-locale={locale}
        data-template-id={trustPilotConfig["review-data-template-id"]}
        data-businessunit-id={trustPilotConfig["data-businessunit-id"][locale]}
        data-style-height="500px"
        data-style-width="100%"
        data-theme={backgroundColor}
        data-stars="4,5"
        data-review-languages="en"
      >
        <a
          href={trustPilotConfig.url[locale]}
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>
      </div>
    </div>
  )
}
